import { type FC, type ReactNode } from "react";
import * as styles from "./styles.css";

type Props = {
  children: ReactNode;
};

export const PublicationArticleContainer: FC<Props> = ({ children }) => {
  return <article className={styles.article}>{children}</article>;
};
